export { default } from './annotation-popup-add.tsx';